import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { AppSharedModule } from './../shared/appShared.module';

import { ProductionComponent } from './production.component';
import { ProductionFormComponent } from './components/production-form.component';
import { ProductionListComponent } from './components/production-list.component';
import {
    ProductionListResolver, ProductionEditResolver,
    ProductionTypeListResolver, ReceptionDropdownResolver
} from './services/production.resolver.service';
import { ProductionService } from './services/production.services';
import { ClientListResolver } from './../client/services/client.resolver.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ContextMenuModule } from 'primeng/contextmenu';
import { FileUploadModule } from 'primeng/fileupload';
import { TabsModule } from 'primeng/tabs';

@NgModule({ exports: [
        ProductionComponent,
        ProductionFormComponent,
        ProductionListComponent,
    ],
    declarations: [
        ProductionComponent,
        ProductionFormComponent,
        ProductionListComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        TableModule,
        SharedModule,
        ButtonModule,
        DialogModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        ToggleSwitchModule,
        ContextMenuModule,
        FileUploadModule,
        TabsModule,
        AppSharedModule,
        TranslatePipe, TranslateDirective,
        ReactiveFormsModule,
        KubaExportModule
    ],
    providers: [
        ProductionService,
        ProductionListResolver,
        ProductionEditResolver,
        ProductionTypeListResolver,
        ClientListResolver,
        ReceptionDropdownResolver,
        provideHttpClient(withInterceptorsFromDi())]
})
export class ProductionModule { }
